import anime from 'animejs'
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";

class XVHome {
    constructor() {
        const body = document.querySelector('body');
        const homePage = document.querySelector('#home-page');
        const menu = document.querySelector('.callback-menu');
        var cursorActive = 1;

        this.visibleAnime = {
            banner: 0,
            about: 0
        }
        this.curCustom = document.querySelector('.cur-custom')
        this.scrDir = 'down'

        homePage.addEventListener('click', e => {

            if (e.target.classList.contains('home_banner_btn')) {
                e.preventDefault()
            }
        }, true)


        if (document.querySelector('body').classList.contains('home')) {
        }



        // cursor   

        // const curFade = document.querySelectorAll('.fade-cur');
        // curFade.forEach(el => {
        //     el.addEventListener('mouseenter', function (e) {
        //         curCustom.classList.add('shrink-fade');
        //     }, false)

        //     el.addEventListener('mouseleave', function (e) {
        //         curCustom.classList.remove('shrink-fade');
        //     }, false)
        // });

        // anime({
        //     targets: '.grad-bg',
        //     top: ["-10vh", "-3vh"],
        //     right: ["-20vh", "0vh"],
        //     duration: 10000,
        //     easing: 'easeInSine',
        //     direction: 'alternate',
        //     loop: true
        // });


        this.scrollDir()
        this.home_intro()
        // this.about()
    }
    scrollDir() {
        let lastScr = 0
        let scrCallback = (e) => {
            this.scrDir = window.scrollY > lastScr ? 'down' : 'up';

            lastScr = window.scrollY
        }

        document.addEventListener('scroll', scrCallback);

    }
    home_intro() {
        let bannh = Splitting({ target: '.home-intro h2' });
        let banCha = bannh[0].chars
        console.log();
        setTimeout(() => {
            anime({
                targets: banCha,
                translateY: ['-40', 0],
                duration: 1500,
                delay: anime.stagger(3),
                easing: 'easeOutQuart',
            });
        }, 200)
    }
    about() {
        let about = document.querySelector('#about_section')
        let about_content_imgs = about.querySelectorAll('.img_wrap')
        let about_content_h4 = about.querySelector('h4')
        let about_content_h5 = about.querySelector('h5')
        let about_content_btn = about.querySelector('.btn')
        let about_h_split = Splitting({ target: [about_content_h4, about_content_h5] });
        // let about_h5_split = Splitting({ target: about_content_h5 });
        let h4_chars = about_h_split[0].chars
        let h5_chars = about_h_split[1].chars

        let about_anim = {}

        about_anim.in = () => {

            if (!this.visibleAnime.about) {

                this.visibleAnime.about = 1

                anime({
                    targets: about_content_imgs,
                    easing: 'easeInOutQuint',
                    duration: 2000,
                    opacity: [0, 1],
                    translateY: [80, 0],
                    delay: anime.stagger(250, { from: 'center' }),
                    complete: function (anim) {
                        anime({
                            targets: about_content_imgs,
                            easing: 'easeInOutQuint',
                            duration: 6000,
                            delay: anime.stagger(600, { from: 'center' }),
                            translateY: -30,
                            direction: 'alternate',
                            loop: true,
                        });
                    }
                });

                let h_tl = anime.timeline({
                    easing: 'easeInOutQuint',
                });

                h_tl.add({
                    targets: h4_chars,
                    translateY: [80, 0],
                    opacity: [0, 1],
                    delay: anime.stagger(3),
                }, 1000)

                h_tl.add({
                    targets: h5_chars,
                    translateY: [80, 0],
                    opacity: [0, 1],
                    delay: anime.stagger(6),
                }, '-=600')

                h_tl.add({
                    targets: about_content_btn,
                    opacity: [0, 1],
                }, '-=600')

            }
        }
        about_anim.out = () => {
            if (this.visibleAnime.about) {

                this.visibleAnime.about = 0

                anime.remove([h4_chars, h5_chars, about_content_btn, about_content_imgs])

                anime({
                    targets: [h4_chars, h5_chars, about_content_btn, about_content_imgs],
                    easing: 'easeInOutQuint',
                    duration: 1000,
                    opacity: [1, 0]
                })

            }
        }

        let aboObsOps = {
            threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
        }

        let aboObsCallback = (entries, observer) => {
            let interFloat = parseFloat(entries[0].intersectionRatio);
            let passedFrame = entries[0].boundingClientRect.y > 0
            let interRange = interFloat > 0.05 && interFloat < 0.3

            if (interRange && entries[0].isIntersecting) {
                if (
                    this.scrDir == 'down' && passedFrame ||
                    this.scrDir == 'up' && !passedFrame
                ) {

                    about_anim.in()
                } else if (
                    this.scrDir == 'down' && !passedFrame ||
                    this.scrDir == 'up' && passedFrame
                ) {

                    about_anim.out()
                }
            }
        }

        let aboObserver = new IntersectionObserver(aboObsCallback, aboObsOps)

        aboObserver.observe(about);

    }
    // scroll_animations() {
    //     let options = { rootMargin: '0px', threshold: 0.5 }

    //     let called = {
    //         testimonials: false,
    //     };
    //     let testi_wrap = document.querySelector("#about_section");
    //     if (testi_wrap) {
    //         let testimonials = new IntersectionObserver((entries) => {
    //             if (entries[0].isIntersecting && !called.testimonials) {
    //                 let tl = anime.timeline({
    //                     easing: 'easeOutQuart',
    //                     duration: 2000
    //                 });

    //                 tl.add({
    //                     targets: '.img_wrap',
    //                     opacity: [0, 1],
    //                 });

    //                 called.testimonials = true;
    //             }
    //         }, options);
    //         testimonials.observe(testi_wrap);
    //     }
    //     let banner_wrap = document.querySelector("#banner");

    //     if (banner_wrap) {
    //         let banner = new IntersectionObserver((entries) => {
    //             if (entries[0].isIntersecting) {
    //                 let tl = anime.timeline({
    //                     easing: 'easeOutQuart',
    //                     duration: 3000
    //                 });

    //                 tl.add({
    //                     targets: '.img_wrap',
    //                     opacity: [0, 1],
    //                 });

    //                 this.curCustom.classList.remove('cur-green')

    //             }
    //         }, options);
    //         banner.observe(banner_wrap);
    //     }
    // }
}

if (document.querySelector('body').classList.contains('home') || document.querySelector('body').classList.contains('post-type-archive-product')) {
    let initHome = new XVHome()
}
